import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PartnerOutput, PartnerSearchResponse } from 'pco-product-service-internal-consumer';

export interface PartnerState {
  partners: PartnerSearchResponse[];
  partnerForAccessCode: PartnerOutput | null;
  isLoading: boolean;
  partnerNotFoundForServiceRole: boolean;
  partnerNotFoundComment: string;
  partnerId?: string;
}

export const initialPartnerState: PartnerState = {
  partners: [],
  partnerForAccessCode: null,
  isLoading: false,
  partnerNotFoundForServiceRole: false,
  partnerNotFoundComment: '',
  partnerId: undefined,
};

const partnerSlice = createSlice({
  name: 'PARTNER',
  initialState: initialPartnerState,
  reducers: {
    setPartnerNotFound: (state, action: PayloadAction<boolean>) => {
      state.partnerNotFoundForServiceRole = action.payload;
    },
    setPartnerNotFoundComment: (state, action: PayloadAction<string>) => {
      state.partnerNotFoundComment = action.payload;
    },
    setPartners: (state, action: PayloadAction<PartnerSearchResponse[]>) => {
      state.partners = action.payload;
    },
    setPartnerForAccessCode: (state, action: PayloadAction<PartnerOutput>) => {
      state.partnerForAccessCode = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPartnerId: (state, action: PayloadAction<string>) => {
      state.partnerId = action.payload;
    },
  },
});

export const { setPartners, setPartnerForAccessCode, setIsLoading, setPartnerNotFound, setPartnerNotFoundComment } =
  partnerSlice.actions;
export default partnerSlice.reducer;
